"use strict";
exports.__esModule = true;
exports.BillingResponse = exports.CustomerStatus = exports.AccountStates = exports.BillerAccountStatus = void 0;
var BillerAccountStatus;
(function (BillerAccountStatus) {
    BillerAccountStatus["NEW"] = "new";
    BillerAccountStatus["ACTIVE"] = "active";
    BillerAccountStatus["PAUSED"] = "paused";
    BillerAccountStatus["PENDING"] = "pending";
    BillerAccountStatus["NO_MATCH"] = "no_match";
    BillerAccountStatus["MATCHING"] = "matching";
    BillerAccountStatus["INACTIVE"] = "inactive";
    BillerAccountStatus["CLOSED"] = "closed";
})(BillerAccountStatus = exports.BillerAccountStatus || (exports.BillerAccountStatus = {}));
var AccountStates;
(function (AccountStates) {
    AccountStates["ACTIVE"] = "active";
    AccountStates["PAUSED"] = "paused";
    AccountStates["CANCELED"] = "canceled";
    AccountStates["DELETED"] = "deleted";
    AccountStates["INITIAL"] = "initial";
    AccountStates["SUSPENDED"] = "suspended";
    AccountStates["ROLLOVER"] = "rollover";
    AccountStates["DISPUTE"] = "dispute";
    AccountStates["BLOCKED"] = "blocked";
    AccountStates["REVOKED"] = "revoked";
    AccountStates["NULL"] = "null";
})(AccountStates = exports.AccountStates || (exports.AccountStates = {}));
var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["ACTIVE"] = "active";
    CustomerStatus["DELETED"] = "deleted";
    CustomerStatus["CANCELED"] = "canceled";
})(CustomerStatus = exports.CustomerStatus || (exports.CustomerStatus = {}));
var BillingResponse;
(function (BillingResponse) {
    BillingResponse["INVALID_CREDENTIALS"] = "invalidCredentials";
    BillingResponse["RESET_PASSWORD_REQUIRED"] = "resetPasswordRequired";
    BillingResponse["UNKNOWN"] = "unknown";
    BillingResponse["INVALID_PORTAL_URL"] = "invalidPortalUrl";
})(BillingResponse = exports.BillingResponse || (exports.BillingResponse = {}));
